import {Component, Input, OnInit} from '@angular/core';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {ModalController} from '@ionic/angular';
import {Subscription} from 'rxjs';
import {SyncDocumentsService} from '../../services/sync-documents.service';
import {DocumentModel} from '../../models/document.model';

@Component({
    selector: 'app-loading-modal',
    templateUrl: './loading-modal.page.html',
    styleUrls: ['./loading-modal.page.scss'],
})
export class LoadingModalPage implements OnInit {

    @Input() message: string;
    @Input() document: DocumentModel;
    loadingMsg: string;
    loadingMsgSubs: Subscription;
    loadingStatusSubs: Subscription;
    progress: number;

    constructor(private refreshDatabase: RefreshdatabaseService,
                private modalController: ModalController,
                private syncService: SyncDocumentsService) {
    }

    ngOnInit() {
        this.loadingMsgSubs = this.syncService.loadingMsgSubject.subscribe(msg => {
            this.loadingMsg = msg;
        });
        this.loadingStatusSubs = this.syncService.uploadStatus.subscribe(progress => {
            this.progress = progress;
        });
    }
}

